// src/components/FeaturesRow.jsx
export default function FeaturesRow() {
  const imgs = [
    "/images/Group 104.png",
    "/images/Group 102.png",
    "/images/Group 103.png",
  ];

  return (
    <section id="features" className="bg-[#F2F5FF] border-y">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-4 sm:py-6 grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-3 md:gap-8 items-center">
        {imgs.map((src, i) => (
          <div key={i} className="flex justify-center">
            <img
              src={src}
              alt=""
              loading="lazy"
              className="w-auto h-[clamp(28px,6vw,56px)] object-contain select-none"
              aria-hidden="true"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
